@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(590_122_670)
internal val Res.string.quiz_le_preposizioni_3_opt3: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_3_opt3", "quiz_le_preposizioni_3_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214472, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212056, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213389, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203648, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198848, 59),
      ))
    }

@delegate:ResourceContentHash(-340_020_073)
internal val Res.string.quiz_le_preposizioni_3_opt4: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_3_opt4", "quiz_le_preposizioni_3_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214540, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212124, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213453, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203708, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198908, 51),
      ))
    }

@delegate:ResourceContentHash(-18_658_076)
internal val Res.string.quiz_liste_congiunzione_e: StringResource by lazy {
      StringResource("string:quiz_liste_congiunzione_e", "quiz_liste_congiunzione_e", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214759, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212311, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213656, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203891, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199091, 37),
      ))
    }

@delegate:ResourceContentHash(1_632_592_533)
internal val Res.string.quiz_liste_virgola: StringResource by lazy {
      StringResource("string:quiz_liste_virgola", "quiz_liste_virgola", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214797, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212349, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213694, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203929, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199129, 30),
      ))
    }

@delegate:ResourceContentHash(104_066_022)
internal val Res.string.quiz_mi_ti_srw_1: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_1", "quiz_mi_ti_srw_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215236, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212716, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214089, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204304, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199512, 124),
      ))
    }

@delegate:ResourceContentHash(-2_087_603_168)
internal val Res.string.quiz_mi_ti_srw_1_opt1: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_1_opt1", "quiz_mi_ti_srw_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214828, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212380, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213725, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203960, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199160, 97),
      ))
    }

@delegate:ResourceContentHash(924_485_051)
internal val Res.string.quiz_mi_ti_srw_1_opt2: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_1_opt2", "quiz_mi_ti_srw_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214926, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212470, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213819, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204042, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199258, 81),
      ))
    }

@delegate:ResourceContentHash(652_141_768)
internal val Res.string.quiz_mi_ti_srw_1_opt3: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_1_opt3", "quiz_mi_ti_srw_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215028, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212552, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213917, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204124, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199340, 85),
      ))
    }

@delegate:ResourceContentHash(1_533_179_267)
internal val Res.string.quiz_mi_ti_srw_1_opt4: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_1_opt4", "quiz_mi_ti_srw_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215130, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212630, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213999, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204218, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199426, 85),
      ))
    }

@delegate:ResourceContentHash(-871_474_561)
internal val Res.string.quiz_mi_ti_srw_2: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_2", "quiz_mi_ti_srw_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215689, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213161, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214558, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204749, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199953, 120),
      ))
    }

@delegate:ResourceContentHash(-2_061_200_091)
internal val Res.string.quiz_mi_ti_srw_2_opt1: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_2_opt1", "quiz_mi_ti_srw_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215357, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212833, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214210, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204413, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199637, 93),
      ))
    }

@delegate:ResourceContentHash(-1_527_966_194)
internal val Res.string.quiz_mi_ti_srw_2_opt2: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_2_opt2", "quiz_mi_ti_srw_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215463, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212927, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214324, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204511, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199731, 73),
      ))
    }

@delegate:ResourceContentHash(-411_034_213)
internal val Res.string.quiz_mi_ti_srw_2_opt3: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_2_opt3", "quiz_mi_ti_srw_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215529, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212997, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214402, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204589, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199805, 77),
      ))
    }

@delegate:ResourceContentHash(-1_400_840_100)
internal val Res.string.quiz_mi_ti_srw_2_opt4: StringResource by lazy {
      StringResource("string:quiz_mi_ti_srw_2_opt4", "quiz_mi_ti_srw_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215607, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213083, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214476, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204675, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 199883, 69),
      ))
    }

@delegate:ResourceContentHash(-729_382_207)
internal val Res.string.quiz_mysterious_cartouche_all_known: StringResource by lazy {
      StringResource("string:quiz_mysterious_cartouche_all_known", "quiz_mysterious_cartouche_all_known", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215798, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213274, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214671, 163),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204858, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200074, 151),
      ))
    }

@delegate:ResourceContentHash(993_911_485)
internal val Res.string.quiz_mysterious_cartouche_is_verb: StringResource by lazy {
      StringResource("string:quiz_mysterious_cartouche_is_verb", "quiz_mysterious_cartouche_is_verb", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 215954, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213414, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214835, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 204994, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200226, 101),
      ))
    }

@delegate:ResourceContentHash(-194_082_652)
internal val Res.string.quiz_mysterious_cartouche_missing_is_nilo: StringResource by lazy {
      StringResource("string:quiz_mysterious_cartouche_missing_is_nilo", "quiz_mysterious_cartouche_missing_is_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216072, 209),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213524, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 214949, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205100, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200328, 173),
      ))
    }

@delegate:ResourceContentHash(991_636_746)
internal val Res.string.quiz_mysterious_cartouche_nswt_bity: StringResource by lazy {
      StringResource("string:quiz_mysterious_cartouche_nswt_bity", "quiz_mysterious_cartouche_nswt_bity", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216282, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213702, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215139, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205278, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200502, 147),
      ))
    }

@delegate:ResourceContentHash(-1_076_590_813)
internal val Res.string.quiz_mysterious_cartouche_twt_ankh: StringResource by lazy {
      StringResource("string:quiz_mysterious_cartouche_twt_ankh", "quiz_mysterious_cartouche_twt_ankh", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216438, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213850, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215299, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205422, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200650, 130),
      ))
    }

@delegate:ResourceContentHash(-457_163_685)
internal val Res.string.quiz_mysterious_review_missing_name: StringResource by lazy {
      StringResource("string:quiz_mysterious_review_missing_name", "quiz_mysterious_review_missing_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216585, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 213985, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215442, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205561, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200781, 107),
      ))
    }

@delegate:ResourceContentHash(-828_791_742)
internal val Res.string.quiz_mysterious_review_title: StringResource by lazy {
      StringResource("string:quiz_mysterious_review_title", "quiz_mysterious_review_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216705, 148),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214093, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215546, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205665, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 200889, 132),
      ))
    }

@delegate:ResourceContentHash(-1_381_352_460)
internal val Res.string.quiz_number_gender_declinazione: StringResource by lazy {
      StringResource("string:quiz_number_gender_declinazione", "quiz_number_gender_declinazione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216854, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214222, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215679, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205798, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201022, 115),
      ))
    }

@delegate:ResourceContentHash(1_075_863_849)
internal val Res.string.quiz_number_gender_duale: StringResource by lazy {
      StringResource("string:quiz_number_gender_duale", "quiz_number_gender_duale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 216990, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214350, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215795, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 205918, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201138, 104),
      ))
    }

@delegate:ResourceContentHash(201_177_658)
internal val Res.string.quiz_number_gender_maschile: StringResource by lazy {
      StringResource("string:quiz_number_gender_maschile", "quiz_number_gender_maschile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217107, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214471, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 215904, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206031, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201243, 131),
      ))
    }

@delegate:ResourceContentHash(-808_274_678)
internal val Res.string.quiz_number_gender_multi_duale_masc: StringResource by lazy {
      StringResource("string:quiz_number_gender_multi_duale_masc", "quiz_number_gender_multi_duale_masc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217255, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214611, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216056, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206163, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201375, 107),
      ))
    }

@delegate:ResourceContentHash(1_984_137_242)
internal val Res.string.quiz_number_gender_multi_plurale: StringResource by lazy {
      StringResource("string:quiz_number_gender_multi_plurale", "quiz_number_gender_multi_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217367, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214723, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216160, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206271, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201483, 128),
      ))
    }

@delegate:ResourceContentHash(419_477_346)
internal val Res.string.quiz_number_gender_neutro: StringResource by lazy {
      StringResource("string:quiz_number_gender_neutro", "quiz_number_gender_neutro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217476, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214852, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216293, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206400, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201612, 125),
      ))
    }

@delegate:ResourceContentHash(978_486_584)
internal val Res.string.quiz_number_gender_opt_regola_rigida: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_regola_rigida", "quiz_number_gender_opt_regola_rigida", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217626, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 214986, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216419, 148),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206534, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201738, 140),
      ))
    }

@delegate:ResourceContentHash(889_175_355)
internal val Res.string.quiz_number_gender_opt_ripetere: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_ripetere", "quiz_number_gender_opt_ripetere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217899, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215279, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216728, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206815, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202011, 79),
      ))
    }

@delegate:ResourceContentHash(-734_830_662)
internal val Res.string.quiz_number_gender_opt_ripetere_simboli: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_ripetere_simboli", "quiz_number_gender_opt_ripetere_simboli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217755, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215123, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216568, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206671, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 201879, 131),
      ))
    }

@delegate:ResourceContentHash(1_698_955_715)
internal val Res.string.quiz_number_gender_opt_tre_trattini: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_tre_trattini", "quiz_number_gender_opt_tre_trattini", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 217995, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215363, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216816, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206899, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202091, 75),
      ))
    }

@delegate:ResourceContentHash(878_000_804)
internal val Res.string.quiz_number_gender_opt_trovare_trattini: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_trovare_trattini", "quiz_number_gender_opt_trovare_trattini", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218087, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215439, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216896, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 206979, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202167, 87),
      ))
    }

@delegate:ResourceContentHash(1_961_986_335)
internal val Res.string.quiz_number_gender_opt_u_genere: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_u_genere", "quiz_number_gender_opt_u_genere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218191, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215531, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 216988, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207071, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202255, 99),
      ))
    }

@delegate:ResourceContentHash(-629_803_233)
internal val Res.string.quiz_number_gender_opt_uy: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_uy", "quiz_number_gender_opt_uy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218307, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215639, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217092, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207183, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202355, 53),
      ))
    }

@delegate:ResourceContentHash(1_541_108_992)
internal val Res.string.quiz_number_gender_opt_y: StringResource by lazy {
      StringResource("string:quiz_number_gender_opt_y", "quiz_number_gender_opt_y", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218377, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215697, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217150, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207241, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202409, 52),
      ))
    }

@delegate:ResourceContentHash(135_325_217)
internal val Res.string.quiz_number_gender_raddoppiare: StringResource by lazy {
      StringResource("string:quiz_number_gender_raddoppiare", "quiz_number_gender_raddoppiare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218446, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215750, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217207, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207298, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202462, 142),
      ))
    }

@delegate:ResourceContentHash(1_456_030_132)
internal val Res.string.quiz_number_gender_tre_trattini: StringResource by lazy {
      StringResource("string:quiz_number_gender_tre_trattini", "quiz_number_gender_tre_trattini", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218621, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 215897, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217354, 155),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207441, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202605, 143),
      ))
    }

@delegate:ResourceContentHash(-1_207_403_160)
internal val Res.string.quiz_number_gender_u_plurale: StringResource by lazy {
      StringResource("string:quiz_number_gender_u_plurale", "quiz_number_gender_u_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218777, 168),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216053, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217510, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207597, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202749, 132),
      ))
    }

@delegate:ResourceContentHash(1_856_944_234)
internal val Res.string.quiz_number_gender_uy_femminile: StringResource by lazy {
      StringResource("string:quiz_number_gender_uy_femminile", "quiz_number_gender_uy_femminile", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 218946, 127),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216194, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217647, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207742, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202882, 107),
      ))
    }

@delegate:ResourceContentHash(1_796_679_932)
internal val Res.string.quiz_participi_1_1: StringResource by lazy {
      StringResource("string:quiz_participi_1_1", "quiz_participi_1_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219074, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216302, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217747, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207854, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202990, 122),
      ))
    }

@delegate:ResourceContentHash(-688_791_731)
internal val Res.string.quiz_participi_1_2: StringResource by lazy {
      StringResource("string:quiz_participi_1_2", "quiz_participi_1_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219225, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216453, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 217910, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 207993, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203113, 114),
      ))
    }

@delegate:ResourceContentHash(884_046_924)
internal val Res.string.quiz_participi_1_3: StringResource by lazy {
      StringResource("string:quiz_participi_1_3", "quiz_participi_1_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219344, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216580, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218037, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208120, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203228, 118),
      ))
    }

@delegate:ResourceContentHash(930_884_158)
internal val Res.string.quiz_participi_1_4: StringResource by lazy {
      StringResource("string:quiz_participi_1_4", "quiz_participi_1_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219467, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216711, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218172, 190),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208247, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203347, 158),
      ))
    }

@delegate:ResourceContentHash(-1_308_990_253)
internal val Res.string.quiz_participi_1_5: StringResource by lazy {
      StringResource("string:quiz_participi_1_5", "quiz_participi_1_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219630, 178),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 216878, 170),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218363, 174),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208410, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203506, 158),
      ))
    }

@delegate:ResourceContentHash(-1_942_392_175)
internal val Res.string.quiz_participi_1_6: StringResource by lazy {
      StringResource("string:quiz_participi_1_6", "quiz_participi_1_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 219809, 190),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217049, 182),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218538, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208561, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203665, 190),
      ))
    }

@delegate:ResourceContentHash(-1_458_625_811)
internal val Res.string.quiz_participi_1_7: StringResource by lazy {
      StringResource("string:quiz_participi_1_7", "quiz_participi_1_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220000, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217232, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218725, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208744, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203856, 130),
      ))
    }

@delegate:ResourceContentHash(-1_294_511_725)
internal val Res.string.quiz_participi_1_8: StringResource by lazy {
      StringResource("string:quiz_participi_1_8", "quiz_participi_1_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220147, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217367, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 218872, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 208879, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 203987, 142),
      ))
    }

@delegate:ResourceContentHash(-786_398_231)
internal val Res.string.quiz_particle_iw_1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_1", "quiz_particle_iw_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220786, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218018, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219591, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209550, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204634, 122),
      ))
    }

@delegate:ResourceContentHash(-1_540_356_998)
internal val Res.string.quiz_particle_iw_10: StringResource by lazy {
      StringResource("string:quiz_particle_iw_10", "quiz_particle_iw_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220678, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217906, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219447, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209426, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204526, 107),
      ))
    }

@delegate:ResourceContentHash(630_338_605)
internal val Res.string.quiz_particle_iw_10_opt1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_10_opt1", "quiz_particle_iw_10_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220294, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217506, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219019, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209022, 144),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204130, 140),
      ))
    }

@delegate:ResourceContentHash(-34_608_355)
internal val Res.string.quiz_particle_iw_10_opt2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_10_opt2", "quiz_particle_iw_10_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220435, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217651, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219172, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209167, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204271, 84),
      ))
    }

@delegate:ResourceContentHash(1_041_002_993)
internal val Res.string.quiz_particle_iw_10_opt3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_10_opt3", "quiz_particle_iw_10_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220528, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217736, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219257, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209256, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204356, 92),
      ))
    }

@delegate:ResourceContentHash(309_230_066)
internal val Res.string.quiz_particle_iw_10_opt4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_10_opt4", "quiz_particle_iw_10_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220597, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217821, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219354, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209341, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204449, 76),
      ))
    }

@delegate:ResourceContentHash(999_411_043)
internal val Res.string.quiz_particle_iw_2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_2", "quiz_particle_iw_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 220925, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218121, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219714, 158),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209665, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204757, 138),
      ))
    }

@delegate:ResourceContentHash(1_980_372_085)
internal val Res.string.quiz_particle_iw_3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_3", "quiz_particle_iw_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221064, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218268, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219873, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209800, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 204896, 114),
      ))
    }

@delegate:ResourceContentHash(986_263_907)
internal val Res.string.quiz_particle_iw_4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_4", "quiz_particle_iw_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221179, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218419, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 219996, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 209939, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205011, 122),
      ))
    }

@delegate:ResourceContentHash(1_335_030_339)
internal val Res.string.quiz_particle_iw_5: StringResource by lazy {
      StringResource("string:quiz_particle_iw_5", "quiz_particle_iw_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221306, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218546, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220127, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210070, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205134, 122),
      ))
    }

@delegate:ResourceContentHash(-1_369_783_883)
internal val Res.string.quiz_particle_iw_6: StringResource by lazy {
      StringResource("string:quiz_particle_iw_6", "quiz_particle_iw_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221653, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218921, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220486, 90),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210441, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205465, 86),
      ))
    }

@delegate:ResourceContentHash(2_082_567_439)
internal val Res.string.quiz_particle_iw_6_opt1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_6_opt1", "quiz_particle_iw_6_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221437, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218721, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220270, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210233, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205257, 51),
      ))
    }

@delegate:ResourceContentHash(-2_109_424_877)
internal val Res.string.quiz_particle_iw_6_opt2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_6_opt2", "quiz_particle_iw_6_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221493, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218777, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220326, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210289, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205309, 51),
      ))
    }

@delegate:ResourceContentHash(-661_625_500)
internal val Res.string.quiz_particle_iw_6_opt3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_6_opt3", "quiz_particle_iw_6_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221545, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218821, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220378, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210337, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205361, 51),
      ))
    }

@delegate:ResourceContentHash(1_968_941_128)
internal val Res.string.quiz_particle_iw_6_opt4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_6_opt4", "quiz_particle_iw_6_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221597, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 218869, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220430, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210389, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205413, 51),
      ))
    }

@delegate:ResourceContentHash(-1_728_684_690)
internal val Res.string.quiz_particle_iw_7: StringResource by lazy {
      StringResource("string:quiz_particle_iw_7", "quiz_particle_iw_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221984, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219268, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220821, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210788, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205792, 82),
      ))
    }

@delegate:ResourceContentHash(1_785_760_989)
internal val Res.string.quiz_particle_iw_7_opt1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_7_opt1", "quiz_particle_iw_7_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221744, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219012, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220577, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210532, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205552, 63),
      ))
    }

@delegate:ResourceContentHash(118_189_123)
internal val Res.string.quiz_particle_iw_7_opt2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_7_opt2", "quiz_particle_iw_7_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221812, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219084, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220645, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210600, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205616, 51),
      ))
    }

@delegate:ResourceContentHash(573_679_099)
internal val Res.string.quiz_particle_iw_7_opt3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_7_opt3", "quiz_particle_iw_7_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221864, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219144, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220697, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210660, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205668, 55),
      ))
    }

@delegate:ResourceContentHash(-1_162_811_811)
internal val Res.string.quiz_particle_iw_7_opt4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_7_opt4", "quiz_particle_iw_7_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 221920, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219204, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220753, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210720, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205724, 67),
      ))
    }

@delegate:ResourceContentHash(361_367_037)
internal val Res.string.quiz_particle_iw_8: StringResource by lazy {
      StringResource("string:quiz_particle_iw_8", "quiz_particle_iw_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222415, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219743, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221332, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211263, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206251, 98),
      ))
    }

@delegate:ResourceContentHash(-2_139_451_326)
internal val Res.string.quiz_particle_iw_8_opt1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_8_opt1", "quiz_particle_iw_8_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222071, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219355, 163),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 220908, 183),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 210871, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205875, 159),
      ))
    }

@delegate:ResourceContentHash(1_855_930_599)
internal val Res.string.quiz_particle_iw_8_opt2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_8_opt2", "quiz_particle_iw_8_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222203, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219519, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221092, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211043, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206035, 71),
      ))
    }

@delegate:ResourceContentHash(-42_895_197)
internal val Res.string.quiz_particle_iw_8_opt3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_8_opt3", "quiz_particle_iw_8_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222279, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219599, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221172, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211119, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206107, 67),
      ))
    }

@delegate:ResourceContentHash(546_823_229)
internal val Res.string.quiz_particle_iw_8_opt4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_8_opt4", "quiz_particle_iw_8_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222347, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219667, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221252, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211187, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206175, 75),
      ))
    }

@delegate:ResourceContentHash(273_102_891)
internal val Res.string.quiz_particle_iw_9: StringResource by lazy {
      StringResource("string:quiz_particle_iw_9", "quiz_particle_iw_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222782, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220142, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221767, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211654, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206614, 98),
      ))
    }

@delegate:ResourceContentHash(-1_117_421_581)
internal val Res.string.quiz_particle_iw_9_opt1: StringResource by lazy {
      StringResource("string:quiz_particle_iw_9_opt1", "quiz_particle_iw_9_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222522, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219862, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221467, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211378, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206350, 67),
      ))
    }

@delegate:ResourceContentHash(860_834_025)
internal val Res.string.quiz_particle_iw_9_opt2: StringResource by lazy {
      StringResource("string:quiz_particle_iw_9_opt2", "quiz_particle_iw_9_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222598, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219934, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221543, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211450, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206418, 59),
      ))
    }

@delegate:ResourceContentHash(634_654_829)
internal val Res.string.quiz_particle_iw_9_opt3: StringResource by lazy {
      StringResource("string:quiz_particle_iw_9_opt3", "quiz_particle_iw_9_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222654, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 219998, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221615, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211514, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206478, 71),
      ))
    }

@delegate:ResourceContentHash(-2_106_619_918)
internal val Res.string.quiz_particle_iw_9_opt4: StringResource by lazy {
      StringResource("string:quiz_particle_iw_9_opt4", "quiz_particle_iw_9_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222718, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220074, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221699, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211586, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206550, 63),
      ))
    }

@delegate:ResourceContentHash(-1_966_771_189)
internal val Res.string.quiz_phonetic_confermare_lettura: StringResource by lazy {
      StringResource("string:quiz_phonetic_confermare_lettura", "quiz_phonetic_confermare_lettura", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 222873, 192),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220253, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221874, 184),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211773, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206713, 160),
      ))
    }

@delegate:ResourceContentHash(-486_470_184)
internal val Res.string.quiz_phonetic_omettere_suoni: StringResource by lazy {
      StringResource("string:quiz_phonetic_omettere_suoni", "quiz_phonetic_omettere_suoni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223066, 204),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220430, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 222059, 212),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 211946, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 206874, 164),
      ))
    }

@delegate:ResourceContentHash(2_074_315_462)
internal val Res.string.quiz_phonetic_ordine_spostamenti: StringResource by lazy {
      StringResource("string:quiz_phonetic_ordine_spostamenti", "quiz_phonetic_ordine_spostamenti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223271, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220619, 192),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 222272, 196),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212131, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207039, 160),
      ))
    }

@delegate:ResourceContentHash(-2_062_641_635)
internal val Res.string.quiz_phonetic_pronunciato_due_volte: StringResource by lazy {
      StringResource("string:quiz_phonetic_pronunciato_due_volte", "quiz_phonetic_pronunciato_due_volte", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223468, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220812, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 222469, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212304, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207200, 131),
      ))
    }

@delegate:ResourceContentHash(1_872_317_552)
internal val Res.string.quiz_phonetic_segni_silenziosi: StringResource by lazy {
      StringResource("string:quiz_phonetic_segni_silenziosi", "quiz_phonetic_segni_silenziosi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223624, 198),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 220956, 178),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 222621, 206),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212460, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207332, 158),
      ))
    }

@delegate:ResourceContentHash(1_530_887_037)
internal val Res.string.quiz_phonetic_vietato_omettere: StringResource by lazy {
      StringResource("string:quiz_phonetic_vietato_omettere", "quiz_phonetic_vietato_omettere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 223823, 234),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221135, 210),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 222828, 202),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212639, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207491, 174),
      ))
    }

@delegate:ResourceContentHash(-231_958_555)
internal val Res.string.quiz_places_cosa_significa_hut: StringResource by lazy {
      StringResource("string:quiz_places_cosa_significa_hut", "quiz_places_cosa_significa_hut", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224058, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221346, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223031, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212834, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207666, 78),
      ))
    }

@delegate:ResourceContentHash(-1_278_611_888)
internal val Res.string.quiz_places_cosa_significa_ta: StringResource by lazy {
      StringResource("string:quiz_places_cosa_significa_ta", "quiz_places_cosa_significa_ta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224137, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221433, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223114, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212917, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207745, 77),
      ))
    }

@delegate:ResourceContentHash(258_405_917)
internal val Res.string.quiz_places_opt_duat: StringResource by lazy {
      StringResource("string:quiz_places_opt_duat", "quiz_places_opt_duat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224211, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221515, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223192, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 212995, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207823, 52),
      ))
    }

@delegate:ResourceContentHash(904_433_236)
internal val Res.string.quiz_places_opt_eternita: StringResource by lazy {
      StringResource("string:quiz_places_opt_eternita", "quiz_places_opt_eternita", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224260, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221568, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223245, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213048, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207876, 44),
      ))
    }

@delegate:ResourceContentHash(1_223_309_737)
internal val Res.string.quiz_places_opt_iunu: StringResource by lazy {
      StringResource("string:quiz_places_opt_iunu", "quiz_places_opt_iunu", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224305, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221613, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223294, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213093, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207921, 52),
      ))
    }

@delegate:ResourceContentHash(819_316_657)
internal val Res.string.quiz_places_opt_tempio: StringResource by lazy {
      StringResource("string:quiz_places_opt_tempio", "quiz_places_opt_tempio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224358, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221666, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223351, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213146, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 207974, 50),
      ))
    }

@delegate:ResourceContentHash(1_461_629_768)
internal val Res.string.quiz_places_opt_terra: StringResource by lazy {
      StringResource("string:quiz_places_opt_terra", "quiz_places_opt_terra", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224409, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221721, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223406, 37),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213205, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208025, 37),
      ))
    }

@delegate:ResourceContentHash(-755_583_199)
internal val Res.string.quiz_places_quale_casa_uscire: StringResource by lazy {
      StringResource("string:quiz_places_quale_casa_uscire", "quiz_places_quale_casa_uscire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224447, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221759, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223444, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213243, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208063, 101),
      ))
    }

@delegate:ResourceContentHash(2_115_451_220)
internal val Res.string.quiz_places_quale_duat: StringResource by lazy {
      StringResource("string:quiz_places_quale_duat", "quiz_places_quale_duat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224557, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221865, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223550, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213349, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208165, 94),
      ))
    }

@delegate:ResourceContentHash(-1_442_998_700)
internal val Res.string.quiz_possessivo_suffisso_tf_1: StringResource by lazy {
      StringResource("string:quiz_possessivo_suffisso_tf_1", "quiz_possessivo_suffisso_tf_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224656, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 221972, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223653, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213452, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208260, 93),
      ))
    }

@delegate:ResourceContentHash(1_271_240_456)
internal val Res.string.quiz_possessivo_suffisso_tf_2: StringResource by lazy {
      StringResource("string:quiz_possessivo_suffisso_tf_2", "quiz_possessivo_suffisso_tf_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224754, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222074, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223747, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213550, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208354, 117),
      ))
    }

@delegate:ResourceContentHash(456_036_835)
internal val Res.string.quiz_possessivo_suffisso_tf_3: StringResource by lazy {
      StringResource("string:quiz_possessivo_suffisso_tf_3", "quiz_possessivo_suffisso_tf_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224876, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222192, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223877, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213672, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208472, 69),
      ))
    }

@delegate:ResourceContentHash(1_397_759_807)
internal val Res.string.quiz_possessivo_suffisso_tf_4: StringResource by lazy {
      StringResource("string:quiz_possessivo_suffisso_tf_4", "quiz_possessivo_suffisso_tf_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 224950, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222274, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 223963, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213762, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208542, 101),
      ))
    }

@delegate:ResourceContentHash(-1_585_849_175)
internal val Res.string.quiz_preposizione_dr_1: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_1", "quiz_preposizione_dr_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225256, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222584, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224281, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214072, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208840, 122),
      ))
    }

@delegate:ResourceContentHash(-563_135_105)
internal val Res.string.quiz_preposizione_dr_1_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_1_opt1", "quiz_preposizione_dr_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225060, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222376, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224077, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213864, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208644, 59),
      ))
    }

@delegate:ResourceContentHash(2_134_689_086)
internal val Res.string.quiz_preposizione_dr_1_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_1_opt2", "quiz_preposizione_dr_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225120, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222440, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224141, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213928, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208704, 43),
      ))
    }

@delegate:ResourceContentHash(356_792_695)
internal val Res.string.quiz_preposizione_dr_1_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_1_opt3", "quiz_preposizione_dr_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225164, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222488, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224185, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 213976, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208748, 47),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString21Resources(map: MutableMap<String, StringResource>) {
  map.put("quiz_le_preposizioni_3_opt3", Res.string.quiz_le_preposizioni_3_opt3)
  map.put("quiz_le_preposizioni_3_opt4", Res.string.quiz_le_preposizioni_3_opt4)
  map.put("quiz_liste_congiunzione_e", Res.string.quiz_liste_congiunzione_e)
  map.put("quiz_liste_virgola", Res.string.quiz_liste_virgola)
  map.put("quiz_mi_ti_srw_1", Res.string.quiz_mi_ti_srw_1)
  map.put("quiz_mi_ti_srw_1_opt1", Res.string.quiz_mi_ti_srw_1_opt1)
  map.put("quiz_mi_ti_srw_1_opt2", Res.string.quiz_mi_ti_srw_1_opt2)
  map.put("quiz_mi_ti_srw_1_opt3", Res.string.quiz_mi_ti_srw_1_opt3)
  map.put("quiz_mi_ti_srw_1_opt4", Res.string.quiz_mi_ti_srw_1_opt4)
  map.put("quiz_mi_ti_srw_2", Res.string.quiz_mi_ti_srw_2)
  map.put("quiz_mi_ti_srw_2_opt1", Res.string.quiz_mi_ti_srw_2_opt1)
  map.put("quiz_mi_ti_srw_2_opt2", Res.string.quiz_mi_ti_srw_2_opt2)
  map.put("quiz_mi_ti_srw_2_opt3", Res.string.quiz_mi_ti_srw_2_opt3)
  map.put("quiz_mi_ti_srw_2_opt4", Res.string.quiz_mi_ti_srw_2_opt4)
  map.put("quiz_mysterious_cartouche_all_known", Res.string.quiz_mysterious_cartouche_all_known)
  map.put("quiz_mysterious_cartouche_is_verb", Res.string.quiz_mysterious_cartouche_is_verb)
  map.put("quiz_mysterious_cartouche_missing_is_nilo", Res.string.quiz_mysterious_cartouche_missing_is_nilo)
  map.put("quiz_mysterious_cartouche_nswt_bity", Res.string.quiz_mysterious_cartouche_nswt_bity)
  map.put("quiz_mysterious_cartouche_twt_ankh", Res.string.quiz_mysterious_cartouche_twt_ankh)
  map.put("quiz_mysterious_review_missing_name", Res.string.quiz_mysterious_review_missing_name)
  map.put("quiz_mysterious_review_title", Res.string.quiz_mysterious_review_title)
  map.put("quiz_number_gender_declinazione", Res.string.quiz_number_gender_declinazione)
  map.put("quiz_number_gender_duale", Res.string.quiz_number_gender_duale)
  map.put("quiz_number_gender_maschile", Res.string.quiz_number_gender_maschile)
  map.put("quiz_number_gender_multi_duale_masc", Res.string.quiz_number_gender_multi_duale_masc)
  map.put("quiz_number_gender_multi_plurale", Res.string.quiz_number_gender_multi_plurale)
  map.put("quiz_number_gender_neutro", Res.string.quiz_number_gender_neutro)
  map.put("quiz_number_gender_opt_regola_rigida", Res.string.quiz_number_gender_opt_regola_rigida)
  map.put("quiz_number_gender_opt_ripetere", Res.string.quiz_number_gender_opt_ripetere)
  map.put("quiz_number_gender_opt_ripetere_simboli", Res.string.quiz_number_gender_opt_ripetere_simboli)
  map.put("quiz_number_gender_opt_tre_trattini", Res.string.quiz_number_gender_opt_tre_trattini)
  map.put("quiz_number_gender_opt_trovare_trattini", Res.string.quiz_number_gender_opt_trovare_trattini)
  map.put("quiz_number_gender_opt_u_genere", Res.string.quiz_number_gender_opt_u_genere)
  map.put("quiz_number_gender_opt_uy", Res.string.quiz_number_gender_opt_uy)
  map.put("quiz_number_gender_opt_y", Res.string.quiz_number_gender_opt_y)
  map.put("quiz_number_gender_raddoppiare", Res.string.quiz_number_gender_raddoppiare)
  map.put("quiz_number_gender_tre_trattini", Res.string.quiz_number_gender_tre_trattini)
  map.put("quiz_number_gender_u_plurale", Res.string.quiz_number_gender_u_plurale)
  map.put("quiz_number_gender_uy_femminile", Res.string.quiz_number_gender_uy_femminile)
  map.put("quiz_participi_1_1", Res.string.quiz_participi_1_1)
  map.put("quiz_participi_1_2", Res.string.quiz_participi_1_2)
  map.put("quiz_participi_1_3", Res.string.quiz_participi_1_3)
  map.put("quiz_participi_1_4", Res.string.quiz_participi_1_4)
  map.put("quiz_participi_1_5", Res.string.quiz_participi_1_5)
  map.put("quiz_participi_1_6", Res.string.quiz_participi_1_6)
  map.put("quiz_participi_1_7", Res.string.quiz_participi_1_7)
  map.put("quiz_participi_1_8", Res.string.quiz_participi_1_8)
  map.put("quiz_particle_iw_1", Res.string.quiz_particle_iw_1)
  map.put("quiz_particle_iw_10", Res.string.quiz_particle_iw_10)
  map.put("quiz_particle_iw_10_opt1", Res.string.quiz_particle_iw_10_opt1)
  map.put("quiz_particle_iw_10_opt2", Res.string.quiz_particle_iw_10_opt2)
  map.put("quiz_particle_iw_10_opt3", Res.string.quiz_particle_iw_10_opt3)
  map.put("quiz_particle_iw_10_opt4", Res.string.quiz_particle_iw_10_opt4)
  map.put("quiz_particle_iw_2", Res.string.quiz_particle_iw_2)
  map.put("quiz_particle_iw_3", Res.string.quiz_particle_iw_3)
  map.put("quiz_particle_iw_4", Res.string.quiz_particle_iw_4)
  map.put("quiz_particle_iw_5", Res.string.quiz_particle_iw_5)
  map.put("quiz_particle_iw_6", Res.string.quiz_particle_iw_6)
  map.put("quiz_particle_iw_6_opt1", Res.string.quiz_particle_iw_6_opt1)
  map.put("quiz_particle_iw_6_opt2", Res.string.quiz_particle_iw_6_opt2)
  map.put("quiz_particle_iw_6_opt3", Res.string.quiz_particle_iw_6_opt3)
  map.put("quiz_particle_iw_6_opt4", Res.string.quiz_particle_iw_6_opt4)
  map.put("quiz_particle_iw_7", Res.string.quiz_particle_iw_7)
  map.put("quiz_particle_iw_7_opt1", Res.string.quiz_particle_iw_7_opt1)
  map.put("quiz_particle_iw_7_opt2", Res.string.quiz_particle_iw_7_opt2)
  map.put("quiz_particle_iw_7_opt3", Res.string.quiz_particle_iw_7_opt3)
  map.put("quiz_particle_iw_7_opt4", Res.string.quiz_particle_iw_7_opt4)
  map.put("quiz_particle_iw_8", Res.string.quiz_particle_iw_8)
  map.put("quiz_particle_iw_8_opt1", Res.string.quiz_particle_iw_8_opt1)
  map.put("quiz_particle_iw_8_opt2", Res.string.quiz_particle_iw_8_opt2)
  map.put("quiz_particle_iw_8_opt3", Res.string.quiz_particle_iw_8_opt3)
  map.put("quiz_particle_iw_8_opt4", Res.string.quiz_particle_iw_8_opt4)
  map.put("quiz_particle_iw_9", Res.string.quiz_particle_iw_9)
  map.put("quiz_particle_iw_9_opt1", Res.string.quiz_particle_iw_9_opt1)
  map.put("quiz_particle_iw_9_opt2", Res.string.quiz_particle_iw_9_opt2)
  map.put("quiz_particle_iw_9_opt3", Res.string.quiz_particle_iw_9_opt3)
  map.put("quiz_particle_iw_9_opt4", Res.string.quiz_particle_iw_9_opt4)
  map.put("quiz_phonetic_confermare_lettura", Res.string.quiz_phonetic_confermare_lettura)
  map.put("quiz_phonetic_omettere_suoni", Res.string.quiz_phonetic_omettere_suoni)
  map.put("quiz_phonetic_ordine_spostamenti", Res.string.quiz_phonetic_ordine_spostamenti)
  map.put("quiz_phonetic_pronunciato_due_volte", Res.string.quiz_phonetic_pronunciato_due_volte)
  map.put("quiz_phonetic_segni_silenziosi", Res.string.quiz_phonetic_segni_silenziosi)
  map.put("quiz_phonetic_vietato_omettere", Res.string.quiz_phonetic_vietato_omettere)
  map.put("quiz_places_cosa_significa_hut", Res.string.quiz_places_cosa_significa_hut)
  map.put("quiz_places_cosa_significa_ta", Res.string.quiz_places_cosa_significa_ta)
  map.put("quiz_places_opt_duat", Res.string.quiz_places_opt_duat)
  map.put("quiz_places_opt_eternita", Res.string.quiz_places_opt_eternita)
  map.put("quiz_places_opt_iunu", Res.string.quiz_places_opt_iunu)
  map.put("quiz_places_opt_tempio", Res.string.quiz_places_opt_tempio)
  map.put("quiz_places_opt_terra", Res.string.quiz_places_opt_terra)
  map.put("quiz_places_quale_casa_uscire", Res.string.quiz_places_quale_casa_uscire)
  map.put("quiz_places_quale_duat", Res.string.quiz_places_quale_duat)
  map.put("quiz_possessivo_suffisso_tf_1", Res.string.quiz_possessivo_suffisso_tf_1)
  map.put("quiz_possessivo_suffisso_tf_2", Res.string.quiz_possessivo_suffisso_tf_2)
  map.put("quiz_possessivo_suffisso_tf_3", Res.string.quiz_possessivo_suffisso_tf_3)
  map.put("quiz_possessivo_suffisso_tf_4", Res.string.quiz_possessivo_suffisso_tf_4)
  map.put("quiz_preposizione_dr_1", Res.string.quiz_preposizione_dr_1)
  map.put("quiz_preposizione_dr_1_opt1", Res.string.quiz_preposizione_dr_1_opt1)
  map.put("quiz_preposizione_dr_1_opt2", Res.string.quiz_preposizione_dr_1_opt2)
  map.put("quiz_preposizione_dr_1_opt3", Res.string.quiz_preposizione_dr_1_opt3)
}
